















import { Component, Vue } from 'vue-property-decorator'

import NotFoundHeader from '@/components/NotFoundHeader.vue'

import CustomerNotification from '@/models/customer-notification'

import EventBus from '@/event-bus'
import { AuthActionTypes } from '@/store/modules/auth/actions'
import {
  CustomerNotificationsGetters,
  CustomerNotificationsActionTypes,
} from '@/store/modules/customerNotifications'

@Component({
  components: {
    NotFoundHeader,
  },
  head: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
})
export default class PageNotFound extends Vue {
  get customerName() {
    const customer = this.$store.getters.getCurrentCustomer
    return customer ? `${customer.firstName}` : ''
  }

  get notifications(): CustomerNotification[] {
    return this.$store.getters[
      CustomerNotificationsGetters.HeaderCustomerNotifications
    ]
  }

  get isLogined(): boolean {
    return this.$store.getters.isLogined
  }

  mounted() {
    EventBus.$on('dismissNotification', (id: number) => {
      this.$store.dispatch(CustomerNotificationsActionTypes.Dismiss, id)
    })
  }

  onLogout() {
    this.$store.dispatch(AuthActionTypes.Logout)
  }
}
